import { requestJson } from './client'

export const platformAccountApi = {
  create(body: Record<string, unknown>) { return requestJson('/api/platform/account-create', body) },
  update(body: Record<string, unknown>) { return requestJson('/api/platform/account-update', body) },
}
